import { type Module } from "vuex";
import type { DefaultApi } from "@/api";
import { KomboApplicationStage } from "@/models/kombo_application_stage";
import { KomboApplicationStages } from "@/models/kombo_application_stages";
import type { State as RootState } from "@/stores";
export interface State {
  stages?: KomboApplicationStages;
}
export const module: Module<State, RootState> = {
  namespaced: true,
  state: {
    stages: undefined,
  },
  actions: {
    async getAllStages({ commit }) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getAllStages();
      const stages = new KomboApplicationStages(
        response.data.map(
          (stage: Partial<KomboApplicationStage>) =>
            new KomboApplicationStage(stage),
        ),
      );
      commit("setStages", stages);
      return stages;
    },
    async getPositionStages({ commit }, positionId: number) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getPositionStages(positionId);
      const stages = new KomboApplicationStages(
        response.data.map(
          (stage: Partial<KomboApplicationStage>) =>
            new KomboApplicationStage(stage),
        ),
      );
      commit("setStages", stages);
      return stages;
    },
  },
  mutations: {
    setStages(state, stages: KomboApplicationStages) {
      state.stages = stages;
    },
  },
};
